// extracted by mini-css-extract-plugin
module.exports = {"project":"project_project__3cu8S"};